import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { IUomTableRow } from 'bom/types';
import { TextLine } from 'core/elements';
import { Color } from 'theme/enums';

export const PartNumberCell = ({ data }: ICellRendererParams<IUomTableRow>) => {
  if (!data) {
    return null;
  }

  return (
    <Stack>
      <TextLine text={data.number} />
      <TextLine text={data.description} color={Color.NEUTRAL} isSubText textEllipsis />
    </Stack>
  );
};
